// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface MinusCircleIconSignature {
  Element: SVGSVGElement;
}

export const MinusCircleIcon: TOC<MinusCircleIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.00098C6.486 2.00098 2 6.48698 2 12.001C2 17.515 6.486 22.001 12 22.001C17.514 22.001 22 17.515 22 12.001C22 6.48698 17.514 2.00098 12 2.00098ZM12 20.001C7.589 20.001 4 16.412 4 12.001C4 7.58998 7.589 4.00098 12 4.00098C16.411 4.00098 20 7.58998 20 12.001C20 16.412 16.411 20.001 12 20.001ZM7 13.001V11.001H17V13.001H7Z"/>
</svg>
</template>;